import styled from "styled-components";

export const Wrap = styled("div")`
  width: 985px;
  margin: 0 auto;
`;
